// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import i18n from './locale/i18n'
import store from './store'
import axios from './axios'
import './filter'
import './util/vconsole'
import formValid from './directive/formValid'
import VueScroller from 'vue-scroller'
import uiToast from '@/component/uiToast/index'
import uiConfirm from '@/component/uiConfirm/index'
import uiAlert from '@/component/uiAlert/index'
import uiOpen from '@/component/uiOpen/index'
import checkPage from '@/util/invalidPage'
import VueClipboard from 'vue-clipboard2'
import setLoading from '@/util/global'
import './util/filters'

Vue.use(VueClipboard)

Vue.prototype.$toast = uiToast
Vue.prototype.$confirm = uiConfirm
Vue.prototype.$alert = uiAlert
Vue.prototype.$openApp = uiOpen
Vue.prototype.$Loading = setLoading
Vue.prototype.$valid = formValid
Vue.use(VueScroller)
router.beforeEach(function (to, from, next) {
  // 检测页面是否无效
  checkPage(to.path, next)
})
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})

Vue.prototype.$http = axios
new Vue({
  el: '#app',
  i18n,
  store,
  router,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js